/*eslint-disable */

import appFooter from '@/components/public/common/footer/';
import {
  bus
} from '@/main';
import contestPopup from '@/components/quiz-contest-popup/index';
import countries from '@/services/country.json';
import {
  mapGetters
} from 'vuex';
import variation_random_img1 from '@/assets/images/random_img/oddnary-variation-5.jpg';
import variation_random_img2 from '@/assets/images/random_img/oddnary-variation-7.jpg';
import variation_random_img3 from '@/assets/images/random_img/oddnary-variation-1.jpg';
import variation_random_img4 from '@/assets/images/random_img/oddnary-variation-4.jpg';
import variation_random_img5 from '@/assets/images/random_img/oddnary-variation-2.jpg';
import variation_random_img6 from '@/assets/images/random_img/oddnary-variation-6.jpg';
import welcome from '@/components/welcome-popup/index';

var $ = window.jQuery = require('jquery');
// import auth from '../../services/auth';
// Multi Color Bg Img Of Section
var actvSlide, actvDots, overFlowVis, beforeLineActv, actvAlertPopup, actvAlertTopLine;
var topBannerSlide, topBannerSlide1, topBannerSlide2, topBannerSlide3, topBannerSlide4, topBannerSlide5;
export default {
  name: 'login',
  components: {
    'app-footer': appFooter,
    'welcome-popup': welcome,
    'contest-popup':contestPopup,
  },
  props: [],
  data() {
    return {
      quizBannerData: {},
      isLeaderBoardDone: false,
      redirectTo: '',
      identity: '',
      password: '',
      otp: '',
      submitted: false,
      preloader: true,
      registerConfirmation: false,
      registerConfirmationDetails: {},
      loginFailed: false,
      showPasswordScreen: false,
      loginType: 'password',
      rankHolderDetails:false,
      getPubLeaderboardDetails:{},
      countryList: [],
      imageIndex:'',
      validationPwErr:false,
      showPassword:false,
      loginPwFieldError:false,
      userInActiveError : false
    }
  },
  computed: {
    ...mapGetters([
      'isAuthenticated',
      'getQuizBannerGetter',
      'registerConfirmationDetailsState',
      'publicLeaderboardGetters'
    ]),
    getRegisterConfirmationDetails() {
      this.registerConfirmationDetails = this.$store.getters.registerConfirmationDetailsState
      if (this.registerConfirmationDetails.code == '2002') {
        this.registerConfirmation = true
      }
    },
    getQuizBanner() {
      this.$store.dispatch('getQuizBannerData')
        .then(res => {
          this.quizBannerData = this.$store.getters.getQuizBannerGetter.data.results;
        })
        .catch(err => {})
    },
  },
  mounted() {
    this.redirectTo = this.$route.query.redirect;
    this.getRegisterConfirmationDetails
    bus.$emit('hideHeaderbtn', false);
    bus.$emit('showLoginbtn', false);
    bus.$emit('showRegisterbtn', true);
    bus.$emit('showHomeMenuBtn', true);
    bus.$emit('showQuizMenubtn', true);
    if (localStorage.getItem('token')) {
      if (this.redirectTo != undefined) {
        let redirect_login = this.redirectTo.split('/')
        if(redirect_login[redirect_login.lastIndexOf('login')] == 'login'){
          this.$router.push('/profile/');
        }else{
          this.$router.push({
            path: this.redirectTo
          });
        }
      } else {
        this.$router.push('/profile/');
      }
    }
    this.randomImgLoaded()
    this.getQuizBanner
    if (process.env.NODE_ENV == 'production') {
      this.$scriptLoader.load("https://www.googletagmanager.com/gtag/js?id=UA-152519411-1")
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'UA-152519411-1');
    }
    $('.routeloader').hide();
    localStorage.removeItem('Reset_Email')

    // Quiz Contest Popup JS
    $('.quiz_contest_alert_inner').slideUp()
    $('.quiz_contest_btn_wrp').removeClass('active_slide')
    $('.quiz_contest_dots').removeClass('active_dots')
    $('.quiz_contest_btn_txt').removeClass('overflow_vis')
    $('.quiz_contest_alert_before_line').removeClass('quiz_contest_alert_before_line_act')
    actvSlide = setTimeout(() => {
      $('.quiz_contest_btn_wrp').addClass('active_slide')
    }, 2800);
    actvDots = setTimeout(() => {
      $('.quiz_contest_dots').addClass('active_dots')
    },6200);
    overFlowVis = setTimeout(() => {
      $('.quiz_contest_btn_txt').addClass('overflow_vis')
    },6000);
    beforeLineActv = setTimeout(() => {
      $('.quiz_contest_alert_before_line').addClass('quiz_contest_alert_before_line_act')
    },7000);
    actvAlertPopup = setTimeout(() => {
      $('.quiz_contest_alert_inner').slideDown(1000)
    actvAlertTopLine = setTimeout(()=>{
        $('.quiz_contest_alert_popup').addClass('active_contest_alert_popup')
      },1600)
    }, 7000);
    $('.quiz_start_popup').click(function(event){
        setTimeout(()=>{
          $(".quiz_contest_popup").addClass('actv_contest')
          $("body").addClass('contest_popup_active')
          setTimeout(()=>{
            $(".quiz_contest_popup_wrp").addClass('actv_contest_popup')
          },100)
        },5)
    })
    $(document).click(function(event) {
      if (!$(event.target).closest(".quiz_start_popup, .quiz_contest_popup").length) {
        $("body").removeClass('contest_popup_active')
        $(".quiz_contest_popup").removeClass('actv_contest')
        $(".quiz_contest_popup_wrp").removeClass('actv_contest_popup')
      }
    });
    $(document).on('click', '.contest_home_icon', function(){
      $("body").removeClass('contest_popup_active')
      $(".quiz_contest_popup").removeClass('actv_contest')
      $(".quiz_contest_popup_wrp").removeClass('actv_contest_popup')
    });
    window.addEventListener('keyup', function(event) {
      // If  ESC key was pressed...
      if (event.keyCode === 27) {
        $("body").removeClass('contest_popup_active')
        $(".quiz_contest_popup").removeClass('actv_contest')
        $(".quiz_contest_popup_wrp").removeClass('actv_contest_popup')
      }
  });
  // Top Rank Holder Button Animation
    Object.keys(countries).map((key, index) => {
      this.countryList.push({
        name: countries[key].toLowerCase(),
        value: key.toLowerCase()
      })
    });
  $(document).ready(function(){
    topBannerSlide = setTimeout(() => {
      $('.top_rank_holder').addClass('actv_top_rank_animation')
    }, 1600);
    topBannerSlide1 = setTimeout(()=>{
        $('.top_rank_holder_animation_btn').addClass('rank_holder_l_aniation_start')
    },4400)
    topBannerSlide2 = setTimeout(()=>{
        $('.top_rank_holder').addClass('rank_holder_l_aniation_finished')
    },5600)
  })
  var _self =  this
  $(document).click(function(event) {
    if (!$(event.target).closest(".rank_holder_user_details, .rank_holder_btn_txt").length) {
      _self.rankHolderPopupClosed()
    }
  });
  },
  methods: {
    passwordErrorHideMethod(){
      this.loginPwFieldError = false
      this.userInActiveError = false
      this.validationPwErr = false
    },
    rankHolderPopupEnabled(){
      if(!this.isLeaderBoardDone) {
        this.$store.dispatch('getPublicLeaderboardListFun')
          .then(res => {
            this.getPubLeaderboardDetails = this.$store.getters.publicLeaderboardGetters.data;
          })
          .catch(err => {})
        this.isLeaderBoardDone = true;
      }
    },
    rankHolderAnimation() {
      this.rankHolderDetails = true
      $('body').addClass('rankHolderDetailsMain')
      topBannerSlide3 = setTimeout(()=>{
        $('.rank_holder_user_details_animation').addClass('rank_holder_show_content')
      },300)
      topBannerSlide4 = setTimeout(()=>{
        $('.rank_holder_user_details').addClass('overflow_content_show')
      },1500)
    },
    rankHolderPopupClosed(){
      this.rankHolderDetails = false
      $('body').removeClass('rankHolderDetailsMain')
      $('.rank_holder_user_details_animation').removeClass('rank_holder_show_content')
      $('.rank_holder_user_details').removeClass('overflow_content_show')
    },
    getCountryFlag: function(countryCode, type) {
      if (countryCode == null) {
        countryCode = ''
      }
      let countryName = countryCode.toLowerCase()
      let country = this.countryList.filter(item => (item.value) == (countryName) || (item.name) == (countryName));
      if (country && country.length > 0) {
        country = country[0]
        if (type == 'flag') {
          country = `http://567c9b4f06e54c9c9229fe11191a6432.s3.ca-central-1.amazonaws.com/media/country/${country.value}.png`
        } else {
          country = country.name
        }
      } else {
        country = ''
      }
      return country;
    },
    randomImgLoaded() {
      $('.app-loader').show()
      // Multi Color Bg Img Of Section
      var images = ["random_img1", "random_img2", "random_img3", "random_img4", "random_img5", "random_img6"]
      var variation_images = [variation_random_img1, variation_random_img2, variation_random_img3, variation_random_img4, variation_random_img5, variation_random_img6]
      var size = images.length;
      var x = Math.floor(size * Math.random());
      this.imageIndex = x
      var element = document.getElementsByClassName('random_bgimg');
      if (x < images.length) {
        element[0].style["background-image"] = "url(" + variation_images[x] + ")"
        $('.section_heading_landing').addClass('act_clr' + x);
        $('.quiz_contest_actv_wrp').addClass('act_contest_clr' + x);
        $('.navbar_list_wrp').addClass('act_contest_clr_of_holders' + x);
        $('.top_rank_holder').addClass('act_contest_clr_of_holders' + x);
        setTimeout(() => {
          this.preloader = false;
          $('.app-loader').hide()
        }, 1500);
      }
    },
    validateLoginFormBeforeSubmit(){
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.submitted = true;
          this.$store.dispatch('login', {
            email: this.identity,
            password: this.password
            })
            .then((res) => {
              $('.app-loader').show()
              this.preloader = true;
              if (res.data.code == '1003') {
                this.preloader = false;
                this.submitted = false
                $('.app-loader').hide()
                if (this.redirectTo != undefined) {
                  let redirect_login = this.redirectTo.split('/')
                  if(redirect_login[redirect_login.lastIndexOf('login')] == 'login'){
                    this.$router.push('/profile/');
                  }else{
                    this.$router.push({
                      path: this.redirectTo
                    });
                  }
                } else {
                  this.$router.push('/profile/');
                }
              }
            }).catch((err) => {
              this.submitted = false
            })
          return;
        }
      });
    },
  },
  beforeCreate: function() {
    $('body').addClass('login public-routes')
    document.title = ' Oddvega - Login';
  },
  beforeRouteLeave: function(to, from, next) {
    $('.navbar_list_wrp').removeClass('act_contest_clr_of_holders' + this.imageIndex);
    $('body').removeClass('login public-routes')
    clearTimeout(actvSlide);
    clearTimeout(actvDots);
    clearTimeout(overFlowVis);
    clearTimeout(beforeLineActv);
    clearTimeout(actvAlertPopup);
    clearTimeout(actvAlertTopLine)
    clearTimeout(topBannerSlide)
    clearTimeout(topBannerSlide1)
    clearTimeout(topBannerSlide2)
    clearTimeout(topBannerSlide3)
    clearTimeout(topBannerSlide4)
    $("body").removeClass('contest_popup_active')
    $('body').removeClass('rankHolderDetailsMain')
    $('.rank_holder_user_details_animation').removeClass('rank_holder_show_content')
    $('.rank_holder_user_details').removeClass('overflow_content_show')
    next();
    $('.navbar_list_wrp').removeClass('act_contest_clr_of_holders' + this.imageIndex);
  },
}